import React from 'react';
import styles from './FilesBlock.module.scss';
import Card from '../Card/Card';
import UploadFile from '../UploadFile/UploadFile';
import FileList from '../FileList/FileList';
import FileEmpty from '../FileEmpty/FileEmpty';
import { Form, Icon, message } from 'antd';
import { documentDrawerSelector } from '../../store/selectors/new-document.selector';
import { useSelector } from 'react-redux';
import useDocsAttachmentsQuery from '../../queries/useDocsAttachmentsQuery';
import useAddDocsAttachFile from '../../mutation/useAddDocsAttachFile';
import { ALLOWED_DOC_ATTACHMENT_FILE_FORMATS } from '../../constants/allowedDocAttachmentFileFormats';

const MAX_FILE_SIZE = 15728640; // 15 mb

const FilesBlock = ({ form, handleFilesChange, onChangePreview }) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;

  const { documentId, mode } = useSelector(documentDrawerSelector);

  const { onMutation, isLoading } = useAddDocsAttachFile();

  const { data: docsAttachments, isFetching } = useDocsAttachmentsQuery(
    documentId,
    {
      enabled: Boolean(documentId),
    }
  );

  const files = getFieldValue('addonfiles');

  const removeFile = (index) => {
    const newFiles = files.filter((_, i) => i !== index);
    if (!newFiles || newFiles?.length === 0) {
      onChangePreview(null);
    }
    setFieldsValue({ addonfiles: newFiles });
    handleFilesChange(newFiles);
  };

  const filesFiltered = mode === 'edit' ? docsAttachments : files;

  const handleChangeFile = async (files) => {
    const fileArray = Array.isArray(files) ? files : [files];

    const validFiles = fileArray.filter((file) => {
      if (!file?.originFileObj) {
        message.error(`Файл ${file.name}: не найден объект`);
        return false;
      }

      if (file.size > MAX_FILE_SIZE) {
        message.error(`Файл ${file.name} весит больше 15 мб`);
        return false;
      }

      const isValidFormat = ALLOWED_DOC_ATTACHMENT_FILE_FORMATS.some((format) =>
        file.name
          .toLowerCase()
          .endsWith(
            format.startsWith('.')
              ? format.toLowerCase()
              : `.${format.toLowerCase()}`
          )
      );

      if (!isValidFormat) {
        message.error(`Файл ${file.name} имеет недопустимый формат`);
        return false;
      }

      return true;
    });

    if (validFiles.length === 0) {
      message.warning('Нет файлов для загрузки');
      return;
    }

    await onMutation({ docId: documentId, files: validFiles });
  };

  return (
    <div className={styles.root}>
      {isFetching ? (
        <Icon
          type="loading"
          style={{ margin: 'auto', color: '#0995ED', fontSize: 20 }}
        />
      ) : (
        <>
          <Card
            heading="Добавить файлы документа"
            description="Можете добавить несколько файлов"
          >
            {mode === 'edit' ? (
              <UploadFile
                value={docsAttachments}
                onChange={handleChangeFile}
                isLoading={isLoading}
              />
            ) : (
              <Form.Item>
                {getFieldDecorator('addonfiles', {
                  valuePropName: 'value',
                  rules: [
                    {
                      required: true,
                      message: 'Пожалуйста прикрепите файлы документа',
                    },
                  ],
                  getValueFromEvent: (e) => e,
                })(<UploadFile handleFilesChange={handleFilesChange} />)}
              </Form.Item>
            )}
          </Card>
          {filesFiltered?.length ? (
            <FileList
              files={filesFiltered}
              removeFile={removeFile}
              onChangePreview={onChangePreview}
            />
          ) : (
            <FileEmpty />
          )}
        </>
      )}
    </div>
  );
};

export default FilesBlock;
